import Vue from 'vue'
import app from './ArticleSaving.vue'
import VueCookie from 'vue-cookie'

if (!window._babelPolyfill) {
  require('@babel/polyfill')
}

Vue.use(VueCookie)

new Vue({
  el: '#article-saving',
  render: h => h(app)
})

const byline = document.querySelector('[data-byline]')
let lastPosition = 0
let ticking = false
let bylineOffset = byline.offsetTop

function addBylineShadow(scrollPosition) {
  if (scrollPosition >= bylineOffset) {
    byline.classList.add('--with-shadow')
  } else {
    byline.classList.remove('--with-shadow')
  }
}

if (window.screen.width >= 768) {
  window.addEventListener('scroll', function() {
    lastPosition = window.scrollY

    if (!ticking) {
      window.requestAnimationFrame(function() {
        addBylineShadow(lastPosition)
        ticking = false
      })

      ticking = true
    }
  })
}
